import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import "./propertiesLanding.css";

function buildPropertyUrl(domain) {
  const d = String(domain || "").trim();
  if (!d) return "";

  if (d.startsWith("http://") || d.startsWith("https://")) return d;

  const isLocal = d.includes("localhost") || d.includes("127.0.0.1") || d.includes(":");
  const protocol = isLocal ? "http" : "https";
  return `${protocol}://${d}`;
}

export default function PropertiesLanding() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchProperties = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axiosPrivate.get("/properties");
        const list = Array.isArray(res?.data?.properties) ? res.data.properties : [];
        if (cancelled) return;
        setProperties(list);
      } catch (err) {
        if (cancelled) return;
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load properties";
        setError(msg);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchProperties();

    return () => {
      cancelled = true;
    };
  }, [axiosPrivate, navigate]);

  // const mainDomain = useMemo(() => {
  //   const main = (properties || []).find((p) => p?.isMain);
  //   return main?.domain || properties?.[0]?.domain || "";
  // }, [properties]);

  const cards = useMemo(() => {
    return (properties || []).map((p) => {
      const domain = p?.domain;
      const name = p?.name || domain;
      return {
        id: p?.id || domain,
        name,
        domain,
        url: buildPropertyUrl(domain),
      };
    });
  }, [properties]);

  const openProperty = (url) => {
    if (!url) return;
    window.location.href = url;
  };

  return (
    <div className="default">
      <div className="stripe properties-landing">
        <div className="container properties-landing__container">
          <h2 className="properties-landing__title">Our Destinations</h2>

          <div className="properties-landing__actions">
            <button
              type="button"
              className="properties-landing__actionBtn"
              onClick={() => navigate("/edit/dashboard")}
            >
              Go to Dashboard
            </button>
          </div>

          {loading && (
            <div className="properties-landing__status">Loading…</div>
          )}

          {!loading && error && (
            <div className="properties-landing__status properties-landing__status--error">
              {error}
            </div>
          )}

          {!loading && !error && (
            <div className="properties-landing__grid">
              {cards.map((c) => (
                <div
                  key={c.id}
                  className="properties-landing__card"
                  onClick={() => openProperty(c.url)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") openProperty(c.url);
                  }}
                >
                  <div className="properties-landing__image" />

                  <div className="properties-landing__content">
                    <h3 className="properties-landing__cardTitle">{c.name}</h3>
                    <p className="properties-landing__cardSubtitle">{c.domain}</p>
                  </div>

                  <button
                    type="button"
                    className="properties-landing__button"
                    onClick={(e) => {
                      e.stopPropagation();
                      openProperty(c.url);
                    }}
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
